import { FuelTypography, FuelDivider, FuelRadio, FuelButton } from '@frete.com/fuel-react'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import { InfoBoxPlus } from '~components'
import { useTranslator } from '~hooks'
import { FuelFlex } from '@frete.com/fuel-station-react'
import { CheckoutProps } from './interfaces'
import { money } from '~utils/money'

const Checkout = ({ product, handleClickUpgradePlan, onConfirm }: CheckoutProps) => {
  const { k, t } = useTranslator()

  return (
    <FuelFlex
      testId='drawer-checkout'
      defaultProps={{
        flexDirection: 'column',
        width: '100%',
        gap: 'km8',
        alignItems: 'flex-start',
        height: '100%',
        justifyContent: 'space-between',
        customPadding: '83px 0px 0px 0px',
      }}
    >
      <FuelFlex
        defaultProps={{
          customPadding: '0px 32px 32px 32px',
          flexDirection: 'column',
        }}
      >
        <FuelTypography size="body-lg" weight="bold" spacingTop={parseInt(theme.spacing.km4)}>
          {t(k.translation.PRODUCT)}
        </FuelTypography>
        <FuelTypography size="body-sm" weight="medium" spacingTop={parseInt(theme.spacing.km4)}>
          {product.name}
        </FuelTypography>

        <FuelTypography
          size="caption"
          color="neutral-default"
          spacingTop={parseInt(theme.spacing.km4)}
          spacingBottom={parseInt(theme.spacing.km8)}
        >
          {product.description}
        </FuelTypography>

        <FuelDivider />

        <FuelTypography
          size="body-md"
          weight="bold"
          spacingTop={parseInt(theme.spacing.km8)}
          spacingBottom={parseInt(theme.spacing.km4)}
        >
          {t(k.translation.PAYMENT_FORM)}
        </FuelTypography>
        <div
          style={{
            border: `${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.medium}`,
            borderRadius: `${theme.border.radius.default}`,
            padding: parseInt(theme.spacing.km4),
          }}
        >
          <FuelRadio checked={true} readOnly label={t(k.translation.EXTRA_PRODUCTS_INVOICE)} />
        </div>

        <FuelTypography size="body-sm" weight="medium" spacingTop={parseInt(theme.spacing.km4)}>
          {t(k.translation.PRODUCT_DISCLAIMER, { product: product.name, price: money(product.price) })}
        </FuelTypography>
      </FuelFlex>

      <FuelFlex defaultProps={{ flexDirection: 'column', width: '100%' }}>
        <InfoBoxPlus handleClickUpgradePlan={handleClickUpgradePlan} />
        <div style={{ marginTop: theme.spacing.km8 }} />
        <FuelDivider size="large" />
        <FuelFlex>
          <div
            style={{
              padding: '0px 32px',
              marginTop: theme.spacing.km6,
              marginBottom: theme.spacing.km6,
              gap: theme.spacing.km4,
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              display: 'flex',
            }}
          >
            <FuelTypography weight="bold" size="body-sm">
              {t(k.translation.PURCHASE_AMOUNT)} {money(product.price)}
            </FuelTypography>
            <FuelButton trailingIcon="arrow-right" onClick={onConfirm} data-testid='checkout-product-buy-now'>{t(k.translation.BUY_NOW)}</FuelButton>
          </div>
        </FuelFlex>
      </FuelFlex>
    </FuelFlex>
  )
}

export default Checkout
